<template>
<label :for="safeId" class="d-block cursor-pointer mb-0">
    <input
        @change="onChange($event)"
        type="file"
        name="src"
        hidden
        :id="safeId"
        :disabled="disabled"
        :multiple="multiple"
    />
    <CCard
        :style="{
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            backgroundColor: disabled ? '#d8dbe0' : 'inherit'
        }"
        class="m-auto text-center"
        :class="inpClass"
    >
        <slot name="card-body-wrapper">
            <CCardBody>
                <slot name="card-body"></slot>
            </CCardBody>
        </slot>
        <slot name="after-card-body"></slot>
    </CCard>
    <slot name="invalid-feedback"></slot>
</label>
</template>

<script>
export default {
    name: 'CImageInputFile',
    inheritAttrs: false,

    props: {
        disabled: {
            type: Boolean
        },
        inpClass: {
            type: [String, Object, Array],
            default: ''
        },
        multiple: {type: Boolean, default: false},
    },

    data() {
        return {
            safeId: this.generateSafeId(),
        }
    },

    methods: {
        generateSafeId () {
            const key = Math.random().toString(36).replace('0.', '')
            return '_safe_id_' + key
        },
        onChange(e) {
            this.$emit('change', e)
        }
    }
}
</script>